"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _molecules = require("../../molecules");

var _Sidebar = _interopRequireDefault(require("../Sidebar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageWrapper = function PageWrapper(_ref) {
  var menuProps = _ref.menuProps,
      bodyProps = _ref.bodyProps,
      headerProps = _ref.headerProps,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_molecules.SessionHeader, headerProps), /*#__PURE__*/_react.default.createElement(_Sidebar.default, menuProps, /*#__PURE__*/_react.default.createElement(_molecules.BodyWrapper, bodyProps, children)));
};

PageWrapper.propTypes = {
  menuProps: _propTypes.default.object,
  bodyProps: _propTypes.default.object,
  headerProps: _propTypes.default.object,
  children: _propTypes.default.any
};
var _default = PageWrapper;
exports.default = _default;